import SectionTitle from '../../../components/SectionTitle/SectionTitle';
import './SponsorSectionHeader.css';

export default function SponsorSectionHeader({title, subtitle, subtitleTag}) {

   
   return (
      <div className='aboutUsPage-sponsor-heading'>
         <SectionTitle upText={subtitleTag} downText={title} />
         <div className='aboutUsPage-sponsor-heading-paragraph-container'>
            <p className='aboutUsPage-sponsor-heading-text'>{subtitle}</p>
         </div>
      </div>
   )
}
